/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { socialProfileCandidateResponseDtoSchema } from "./socialProfileCandidateResponseDtoSchema";
import { z } from "zod/v4";

export const socialProfileSuggestionResponseDtoSchema = z.object({
    "platform": z.enum(["linkedin", "instagram", "facebook"]),
get "candidate"(){
               return socialProfileCandidateResponseDtoSchema.nullable()
              },
"score": z.nullable(z.number()),
"meetsThreshold": z.boolean().describe("Whether score clears SOCIAL_PROFILE_CONFIDENCE_THRESHOLD — this preview endpoint returns every candidate found regardless, so the caller can inspect near-misses too"),
"error": z.nullable(z.string().describe("Set when the lookup itself failed (LLM/network error) — distinct from a clean \"no profile found\". Other platforms in the same request are unaffected"))
    })